import { PropTypes } from 'prop-types';
import { useState } from 'react';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { Box, IconButton, Menu } from '@material-ui/core';
import CopyShortLink from './elements/CopyShortLink';
import './DetailKnowledgeViewModeGroupButton.css';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

DetailKnowledgeViewModeGroupButton.propTypes = {
    hasViewPermission: PropTypes.bool,
    hasEditFieldPermissions: PropTypes.bool,
    hasEditSettingPermissions: PropTypes.bool,
    hasChatPermission: PropTypes.bool,
    detailTicket: PropTypes.any,
    setIsOpenDialogConfirmDeleteKnowledge: PropTypes.any,
    setIsShowDialogDeleteTicket: PropTypes.any,
    displayMode: PropTypes.any,
    setDisplayMode: PropTypes.any,
    corporationAffiliationTicket: PropTypes.any,
    onClickDuplicate: PropTypes.any,
    formDetail: PropTypes.any,
    selectedProject: PropTypes.any,
    isGeneralUser: PropTypes.any,
    openChatThreadPanel: PropTypes.any
};

export default function DetailKnowledgeViewModeGroupButton(props) {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const {
        hasViewPermission,
        hasEditFieldPermissions,
        hasEditSettingPermissions,
        hasChatPermission,
        detailTicket,
        setIsOpenDialogConfirmDeleteKnowledge,
        setIsShowDialogDeleteTicket,
        displayMode,
        setDisplayMode,
        corporationAffiliationTicket,
        onClickDuplicate,
        formDetail,
        selectedProject,
        isGeneralUser,
        openChatThreadPanel
    } = props;

    // react-state
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const onClickChangeToEditMode = () => {
        setDisplayMode(Constant.DISPLAY_MODE.EDIT);
    };

    const isDisplayIconEdit = () => {
        if (displayMode !== Constant.DISPLAY_MODE.VIEW) return false;
        if (
            detailTicket?.deletedAt ||
            detailTicket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED
        ) {
            return false;
        }

        // KB_KNOWLEDGE form variant: only allow edit for setting permissions (view/edit permission)
        if (formDetail?.definitionVariant === Constant.FORM_VARIANT.KB_KNOWLEDGE) {
            return hasEditSettingPermissions;
        }

        return hasEditFieldPermissions;
    };

    const isShowButtonDuplicate = () => {
        // Hide duplicate for KB_KNOWLEDGE form variant
        if (formDetail?.definitionVariant === Constant.FORM_VARIANT.KB_KNOWLEDGE) {
            return false;
        }

        // Check on knowledge service
        
        // const knowledgeService = [
        //     Constant.CORPORATION_CONTRACT_TYPE.GUEST,
        //     Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
        // ].includes(corporationAffiliationTicket.contractType)
        //     ? Utils.convertJSONDataToObject(corporationAffiliationTicket?.inviterSetting)
        //           ?.usingKnowledgeService
        //     : corporationAffiliationTicket?.knowledgeService;
        // const isKnowledgeServiceOn = knowledgeService === Constant.STATUS_SERVICE_PERMISSION.ON;

        // Check type ticket
        const isTicketTypeAllowDuplicate =
            [Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(
                detailTicket.ticketType
            ) && !detailTicket.deletedAt;

        // Project base, B2C does not allow duplicates
        const isProjectAllowDuplicate = ![
            Constant.PROJECT_TYPE.BASE,
            Constant.PROJECT_TYPE.CUSTOMER
        ].includes(selectedProject.type);

        // Corp support does not allow duplicates
        const isCorpAllowDuplicate = ![Constant.CORPORATION_CONTRACT_TYPE.GUEST].includes(
            corporationAffiliationTicket.contractType
        );
        return (
            (formDetail?.isFormShareForProject ||
                detailTicket.public === Constant.TICKET_PUBLIC.DRAFT) &&
            // isKnowledgeServiceOn &&
            isTicketTypeAllowDuplicate &&
            isProjectAllowDuplicate &&
            isCorpAllowDuplicate
        );
    };

    const isShowIconChat = () => {
        return hasChatPermission && detailTicket?.public === Constant.TICKET_PUBLIC.PUBLIC;
    };

    const isShowIconSoftDelete = () => {
        return Utils.isEmptyString(detailTicket?.deletedAt) && hasEditFieldPermissions === true;
    };

    const isBlockedByPageCreation = () => {
        if (
            ![Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(
                detailTicket?.ticketType
            )
        ) {
            return false;
        }
        const attachment = detailTicket?.attachment || [];
        return attachment.some(f => f.isCreatingPageKnowledge && f.isPdf && f.splitPdf);
    };

    const isShowIconPermanentDelete = () => {
        return (
            !Utils.isEmptyString(detailTicket?.deletedAt) &&
            (hasEditFieldPermissions || hasEditSettingPermissions)
        );
    };

    const isDisplayIconHamburger =
        isShowIconChat() ||
        isShowButtonDuplicate() ||
        isShowIconSoftDelete() ||
        isShowIconPermanentDelete();

    return (
        <div className="view-mode-group-btn">
            {isDisplayIconEdit() && (
                <IconButton className="itemNav" onClick={() => onClickChangeToEditMode()}>
                    <img src="/assets/image/icon-edit-mode.svg" alt="Edit mode" />
                </IconButton>
            )}

            {!Utils.isEmptyObject(detailTicket?.dataShareLink) && (
                <CopyShortLink
                    detailTicket={detailTicket}
                    isGeneralUser={isGeneralUser}
                    corporationDetail={corporationAffiliationTicket}
                />
            )}

            {/* hamburger icon */}
            {isDisplayIconHamburger && (
                <IconButton
                    className="close"
                    aria-label="more"
                    id="long-button-hamburger"
                    aria-controls={open ?? 'long-menu'}
                    aria-expanded={open ?? 'true'}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <img src="/assets/image/icon-hamburger.svg" alt="Icon hamburger" />
                </IconButton>
            )}

            <Menu
                id="long-menu-hamburger"
                className="view-mode-group-btn"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                MenuListProps={{
                    className: 'view-mode-group-btn-hamburger'
                }}
                PaperProps={{
                    style: {
                        minWidth: '160px',
                        minHeight: '40px'
                    }
                }}
            >
                <div className="hamburger-list">
                    {/* Chat */}
                    {isShowIconChat() && (
                        <Box
                            className="hamburger-item"
                            onClick={() => {
                                openChatThreadPanel(detailTicket);
                                handleClose();
                            }}
                        >
                            <IconButton className="itemNav" disabled={!hasViewPermission}>
                                <img src="/assets/image/icon-chat-knowledge.svg" alt="" />
                            </IconButton>
                            {trI18n('HAMBURGER-KNOWLEDGE-CHAT')}
                        </Box>
                    )}

                    {/* Duplicate */}
                    {isShowButtonDuplicate() && (
                        <Box
                            className="hamburger-item"
                            onClick={() => {
                                onClickDuplicate();
                                handleClose();
                            }}
                        >
                            <IconButton className="itemNav">
                                <img src="/assets/image/icon-copy.svg" alt="" />
                            </IconButton>
                            {trI18n('HAMBURGER-DUPLICATE')}
                        </Box>
                    )}

                    {/* Soft delete */}
                    {isShowIconSoftDelete() && (
                        <Box
                            className={`hamburger-item ${isBlockedByPageCreation() ? 'hamburger-item-disabled' : ''}`}
                            onClick={() => {
                                if (isBlockedByPageCreation()) return;
                                setIsOpenDialogConfirmDeleteKnowledge(true);
                                handleClose();
                            }}
                        >
                            <IconButton className="itemNav" disabled={isBlockedByPageCreation()}>
                                <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                            </IconButton>
                            {trI18n('HAMBURGER-DELETE')}
                        </Box>
                    )}

                    {/* Permanent delete */}
                    {isShowIconPermanentDelete() && (
                        <Box
                            className={`hamburger-item ${isBlockedByPageCreation() ? 'hamburger-item-disabled' : ''}`}
                            onClick={() => {
                                if (isBlockedByPageCreation()) return;
                                setIsShowDialogDeleteTicket(true);
                                handleClose();
                            }}
                        >
                            <IconButton className="itemNav" disabled={isBlockedByPageCreation()}>
                                <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                            </IconButton>
                            {trI18n('HAMBURGER-PERMANENT-DELETE')}
                        </Box>
                    )}
                </div>
            </Menu>
        </div>
    );
}
